//src/sayfalar/ProtectedClassroomTool.js

import React, { useState } from 'react';
import ClassroomTool from './ClassroomTool.js';
import LoginScreen from './LoginScreen.js';

const ProtectedClassroomTool = () => {
    // Sayfa yenilense bile giriş durumunu hatırlamak için sessionStorage kullanıyoruz.
    const [isAuthenticated, setIsAuthenticated] = useState(
        sessionStorage.getItem('classroomToolAuthenticated') === 'true'
    );

    const handleLoginSuccess = () => {
        // Giriş başarılı olduğunda sessionStorage'a bir işaret bırakıyoruz.
        sessionStorage.setItem('classroomToolAuthenticated', 'true');
        setIsAuthenticated(true);
    };

    // Eğer kullanıcı kimliğini doğruladıysa asıl aracı, doğrulamadıysa giriş ekranını göster.
    return isAuthenticated ? (
        <ClassroomTool />
    ) : (
        <LoginScreen onLoginSuccess={handleLoginSuccess} />
    );
};

export default ProtectedClassroomTool;
